import {Log} from './log';
const log = Log.getLogger('featureToggles');

import {Guard} from './guard';
import {AppConfig} from '../app.config';

import {Injectable} from '@angular/core';

@Injectable()
export class FeatureToggles {

    constructor(private defaultConfig: AppConfig) {
    }

    isEnabled(featureName: string): boolean {
        Guard.required({ featureName });

        const toggles = this.defaultConfig.getValue('featureToggles');
        const toggle = toggles[featureName];

        if (toggle) {
            if (!toggle.enabled) {
                // handle if not enabled
                // log.debug(`toggle '${featureName}' is disabled`);
            }
            return toggle.enabled === true;
        }

        log.warn(`toggle '${featureName}' is not defined, so it is disabled by default`);
        return false;
    }
}



// WEBPACK FOOTER //
// ./app/shared/feature-toggles.ts